import * as flipperFlags from './flipperFlags';
import * as productFlags from './productFlags';

import type { FlipperFlag, LegacyProductFlag, ProductFlipperFlagRelation } from './productFlags.type';

export type { FlipperFlag, LegacyProductFlag, ProductFlipperFlagRelation };

export const AD_LINK_MANAGER: ProductFlipperFlagRelation = {
  name: 'Ad Link Manager',
  product: productFlags.LEGACY_AD_LINK_MANAGER,
  flipper: flipperFlags.AD_LINK_MANAGER,
};

export const AD_LINK_TEMPLATES: ProductFlipperFlagRelation = {
  name: 'Ad Link Templates',
  product: productFlags.LEGACY_AD_LINK_TEMPLATES,
  flipper: flipperFlags.AD_LINK_TEMPLATES,
};

export const BULK_AD_LINKS: ProductFlipperFlagRelation = {
  name: 'Bulk Ad Links',
  product: productFlags.LEGACY_BULK_AD_LINKS,
  flipper: flipperFlags.BULK_AD_LINKS,
};

export const BULK_QUICK_LINKS: ProductFlipperFlagRelation = {
  name: 'Bulk Quick Links',
  product: productFlags.LEGACY_BULK_QUICK_LINKS,
  flipper: flipperFlags.BULK_QUICK_LINKS,
};

export const QUICK_LINK_MANAGER: ProductFlipperFlagRelation = {
  name: 'Quick Link Manager',
  product: productFlags.LEGACY_QUICK_LINK_MANAGER,
  flipper: flipperFlags.QUICK_LINK_MANAGER,
};

export const QUICK_LINK_TEMPLATES: ProductFlipperFlagRelation = {
  name: 'Quick Link Templates',
  product: productFlags.LEGACY_QUICK_LINK_TEMPLATES,
  flipper: flipperFlags.QUICK_LINK_TEMPLATES,
};

export const HOUSEHOLD: ProductFlipperFlagRelation = {
  name: 'Household',
  product: productFlags.LEGACY_HOUSEHOLD,
  flipper: flipperFlags.OTT,
};

export const productFlipperFlagRelations: ProductFlipperFlagRelation[] = [
  AD_LINK_MANAGER,
  AD_LINK_TEMPLATES,
  BULK_AD_LINKS,
  BULK_QUICK_LINKS,
  QUICK_LINK_MANAGER,
  QUICK_LINK_TEMPLATES,
  HOUSEHOLD,
];
